import { Box, Select, Text } from '@chakra-ui/react'

import { Button } from '../Button'

export interface SelectProviderStepIProps {
  providers: Array<{ id: string; providerName: string } | null>
  selectedProviderId: string
  onProviderChange: (id: string) => void
  onLink: () => void
  onClose: () => void
  isLoading: boolean
}

export const SelectProviderStep = ({
  providers,
  selectedProviderId,
  onProviderChange,
  onLink,
  onClose,
  isLoading,
}: SelectProviderStepIProps) => (
  <Box py={2}>
    <Text color='gray.600' fontSize='sm' mb={4}>
      Select a Secret Provider to associate with this entity. HiveWatch will use
      it to retrieve credentials.
    </Text>
    <Select
      mb={6}
      onChange={(e) => onProviderChange(e.target.value)}
      placeholder='Select a provider'
      value={selectedProviderId}
    >
      {providers.map((provider) =>
        provider ? (
          <option key={provider.id} value={provider.id}>
            {provider.providerName}
          </option>
        ) : null
      )}
    </Select>
    <Box display='flex' gap={3} justifyContent='flex-end'>
      <Button onClick={onClose} variant='secondary'>
        Cancel
      </Button>
      <Button
        isDisabled={!selectedProviderId}
        isLoading={isLoading}
        onClick={onLink}
      >
        Associate
      </Button>
    </Box>
  </Box>
)
